import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsPPMPricing from './SettingsPPMPricing';

function PPMPricingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="PPM Pricing"
        subtitle="Configure PPM pricing rules"
        backTo="/settings/finance"
        backLabel="Finance"
        sticky
      />
      <div className="p-6">
        <SettingsPPMPricing />
      </div>
    </div>
  );
}

export default PPMPricingPage;
